var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#D1E0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 14.6673H10M18.6667 9.33398V12.0007M13.3333 9.33398V12.0007M13.2 22.6673H18.8C19.9201 22.6673 20.4802 22.6673 20.908 22.4493C21.2843 22.2576 21.5903 21.9516 21.782 21.5753C22 21.1475 22 20.5874 22 19.4673V13.8673C22 12.7472 22 12.1872 21.782 11.7593C21.5903 11.383 21.2843 11.0771 20.908 10.8853C20.4802 10.6673 19.9201 10.6673 18.8 10.6673H13.2C12.0799 10.6673 11.5198 10.6673 11.092 10.8853C10.7157 11.0771 10.4097 11.383 10.218 11.7593C10 12.1872 10 12.7472 10 13.8673V19.4673C10 20.5874 10 21.1475 10.218 21.5753C10.4097 21.9516 10.7157 22.2576 11.092 22.4493C11.5198 22.6673 12.0799 22.6673 13.2 22.6673Z",
    stroke: "#2970FF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar32);
export default __webpack_public_path__ + "static/media/calendar-32.5fa702f5a4f2d4c6e4b38256ce3f0f60.svg";
export { ForwardRef as ReactComponent };